import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { useParams, useHistory, matchPath } from "react-router-dom";
import * as _ from "lodash";
import style from "./theme.module.sass";
import { Icon, Popover, Divider } from "antd";
import ThemeLock from "../../../assets/svg/theme_lock_white.svg";
import { Modal } from "../../../helpers/commonUi";
import Theme from "./Theme";
import { Http } from "../../../helpers/axois";
import { RXThemeSaveAsnew } from "../../../helpers/RxServices";
import { useDispatch, useSelector } from "react-redux";
import { pushToast } from "../../../stateManager/store/toast/actions";
import { setCurrentTheme } from "../../../stateManager/store/orgs/actions";
import { ReactComponent as EditIcon } from "../../../assets/svg/editIcon.svg";
import { ReactComponent as Delete } from "../../../assets/svg/delete.svg";
import { ReactComponent as PolicyIcon } from "../../../assets/svg/policyIcon.svg";
import { useToast } from "../../../helpers/commonFunction";
import { AttachPolicies } from "../../apps/AttachPolicies";
import { getRandomId } from "../../../utils/random-id";
import { logger } from "../../../constant/winston";

const Sidemenu = (props: any) => {
  const [selectTheme, setselectTheme] = useState();
  const [initialCount, setinitialCount] = useState(0);
  const [customThemeList, setcustomThemeList] = useState([]);
  const [defaultThemeList, setdefaultThemeList] = useState([]);
  const [visible, setvisible] = useState(false);
  const [policyModalVisible, setPolicyModalVisible] = useState(false);
  const [policyModalData, setPolicyModalData] = useState<any>({});
  const [initialState, setinitialState] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [saveAsSource, setsaveAsSource] = useState<any>();
  const currentTheme = useSelector((state: any) => state.org.selectedTheme);
  const params: any = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { ErrorToast } = useToast();
  const setIsForbidden = props.setIsForbidden;

  const themeClick = (data: any) => {
    const themeId = data.theme_id ? data.theme_id : data.id;
    setselectTheme(themeId);
    dispatch(
      setCurrentTheme({
        id: themeId,
        source: data.source,
      })
    );
    history.push(`/organization/${params.orgId}/themeManager/${themeId}`);
  };

  const orgPermissions: any = useSelector(
    (state: any) => {
      return state.org.orgPermissions;
    },
    (oldPermissions: any, newPermissions: any) =>
      JSON.stringify(oldPermissions) === JSON.stringify(newPermissions)
  );

  const canEditTheme = orgPermissions.includes("theme.Edit");
  const canDeleteTheme = orgPermissions.includes("theme.Delete");
  const canCreateTheme = orgPermissions.includes("theme.Create");
  const canViewTeam = orgPermissions.includes("team.View");
  const canViewPolicy = orgPermissions.includes("policy.View");
  const canAttachPolicy = orgPermissions.includes("policy.Attach");
  const canRemovePolicy = orgPermissions.includes("policy.Remove");

  const getTheme = useCallback(() => {
    Http.get(`org/${params.orgId}/themes`).subscribe(
      (res: any) => {
        const group: any = _.groupBy(res, "is_system");
        if (group) {
          setcustomThemeList(group["false"] ? group["false"] : []);
          const orderby: any = _.orderBy(group["true"], "theme_name");
          setdefaultThemeList(orderby);
          const currentThemeId =
            (currentTheme && currentTheme.id) || orderby[0].theme_id;
          if (currentThemeId) {
            setselectTheme(currentThemeId);
            history.push(
              `/organization/${params.orgId}/themeManager/${currentThemeId}`
            );
          } else {
            const themeId = group["false"][0].theme_id;
            if (themeId) {
              setselectTheme(themeId);
              history.push(
                `/organization/${params.orgId}/themeManager/${themeId}`
              );
            }
          }
        }
      },
      (err) => {
        if (err === "Forbidden") {
          setIsForbidden(true);
        }
      }
    );
  }, [params, history, currentTheme, setIsForbidden]);

  useEffect(() => {
    if (initialCount === 0) {
      const matchParams: any = matchPath(history.location.pathname, {
        path: `/organization/${params.orgId}/themeManager/:themeId`,
      });
      if (matchParams) {
        setselectTheme(matchParams.params.themeId);
      } else {
        if (selectTheme)
          history.push(
            `/organization/${params.orgId}/themeManager/${selectTheme}`
          );
      }
      RXThemeSaveAsnew.getMessage().subscribe((res) => {
        setinitialState(null);
        setsaveAsSource(res);
        setvisible(true);
      });
      getTheme();
      setinitialCount(1);
    }
    return () => { };
  }, [initialCount, params, history, selectTheme, getTheme]);

  const editTheme = (e: any, data: any) => {
    setsaveAsSource(null);
    setinitialState(data);
    setvisible(true);
    e.stopPropagation();
    logger.debug("edit theme", data);
  };

  const deleteTheme = (e: any, data: any) => {
    setDeleteData(data);
    setModalVisible(true);
    e.stopPropagation();
  };

  const content = (data: any) => {
    const canEditThemeLocal = data.permissions.includes("theme.Edit");
    const canEditDeleteLocal = data.permissions.includes("theme.Delete");
    const canViewPolicyLocal = data.permissions.includes("policy.View");
    const canAttachPolicyLocal = data.permissions.includes("policy.Attach");
    const canRemovePolicyLocal = data.permissions.includes("policy.Remove");
    const canViewTeamLocal = data.permissions.includes("team.View");
    return (
      <div>
        <div
          data-test-id="edit_theme"
          className={style.sidemenu}
          onClick={(e) => {
            if (canEditTheme || canEditThemeLocal) {
              editTheme(e, data);
            } else {
              ErrorToast("You are not authorized to edit this theme");
            }
          }}
        >
          <EditIcon data-test-id="edit" height="14px" width="14px" /> EDIT
        </div>
        <Divider style={{ margin: "10px 0px" }} />
        <div
          data-test-id="change_theme"
          className={style.sidemenu}
          onClick={(e) => {
            if (
              (canEditTheme || canEditThemeLocal) &&
              (canViewPolicy || canViewPolicyLocal) &&
              (canViewTeam || canViewTeamLocal) &&
              (canAttachPolicy ||
                canAttachPolicyLocal ||
                canRemovePolicy ||
                canRemovePolicyLocal)
            ) {
              setPolicyModalData({
                orgId: data.org_id,
                themeId: data.theme_id,
                canAttach: canAttachPolicy || canAttachPolicyLocal,
                canRemove: canRemovePolicy || canRemovePolicyLocal,
              });
              setPolicyModalVisible(true);
            } else {
              ErrorToast("You are not authorized to change policies of this theme");
            }
          }}
        >
          <PolicyIcon data-test-id="policy" height="14px" width="14px" /> POLICY
        </div>
        <Divider style={{ margin: "10px 0px" }} />
        <div
          data-test-id="delete_theme"
          className={style.sidemenu}
          onClick={(e) => {
            if (canDeleteTheme || canEditDeleteLocal) {
              deleteTheme(e, data);
            } else {
              ErrorToast("You are not authorized to delete this theme");
            }
          }}
        >
          <Delete data-test-id="delete" height="14px" width="14px" /> DELETE
        </div>
      </div>
    );
  };

  const confirm = () => {
    setModalVisible(false);
    const arnName = `themes:${deleteData.theme_id}`;
    Http.delete(
      `themes/${deleteData.theme_id}?orgId=${params.orgId}&arn=${arnName}`
    ).subscribe(
      (res) => {
        getTheme();
        dispatch(
          pushToast({ type: "success", message: "Theme deleted successfully" })
        );
      },
      (err) => {
        dispatch(
          pushToast({
            type: "error",
            message: err && err.message ? err.message : "Theme updation failed",
          })
        );
      }
    );
  };

  return (
    <React.Fragment>
      <div>
        <ul className={"list-group " + style.listgroup} style={{ height: "100%", overflowY: "auto" }}>
          {defaultThemeList.map((data: any, key) => (
            <li
              data-test-id={`theme${data.theme_name}`}
              key={key}
              onClick={() => themeClick(data)}
              className={
                "list-group-item " +
                classNames({ [style.active]: selectTheme === data.theme_id })
              }
              title={data.theme_name}
            >
              <div style={{textOverflow:"ellipsis", whiteSpace:"nowrap", overflow:"hidden" }}>{data.theme_name}</div>
              <img src={ThemeLock} alt="" />
            </li>
          ))}
          {canCreateTheme && (
            <li
              data-test-id="create_theme"
              onClick={() => {
                setsaveAsSource(null);
                setinitialState(null);
                setvisible(true);
              }}
              className={"list-group-item " + style.createTheme}
            >
              <div className={style.button}>Create Theme</div>
            </li>
          )}
          {customThemeList.length > 0 &&
            customThemeList.map((data: any, key) => (
              <li
                data-test-id={`${data.theme_name}`}
                key={key}
                onClick={() => themeClick(data)}
                className={
                  "list-group-item " +
                  classNames({ [style.active]: selectTheme === data.theme_id })
                }
                title={data.theme_name}
              >
                <div style={{textOverflow:"ellipsis", whiteSpace:"nowrap", overflow:"hidden"}}>{data.theme_name}</div>
                <Popover placement="right" title={null} content={content(data)}>
                  <Icon type="more" style={{ marginTop: "6px" }} />
                </Popover>
              </li>
            ))}
        </ul>
      </div>
      {visible && (
        <ThemeModal
          source={saveAsSource}
          key={getRandomId()}
          initialState={initialState}
          getTheme={getTheme}
          visible={visible}
          setvisible={setvisible}
        />
      )}
      {modalVisible && (
        <Modal
          id="deleteTheme"
          dataTestId="delete_theme"
          title="DELETE THEME"
          footer={{
            enable: true,
            cancelText: "CANCEL",
            okText: "DELETE",
            onOk: confirm,
          }}
          onCancel={() => setModalVisible(false)}
          unmountOnCancel={true}
          visible={modalVisible}
          deleteOptions={{
            type: "Theme",
            validateString: deleteData.theme_name,
          }}
        />
      )}
      <Modal
        width="650px"
        id="attachAppPolicies"
        dataTestId="attach_app_policies"
        unmountOnCancel={true}
        visible={policyModalVisible}
        title="ATTACH POLICIES"
        onCancel={() => {
          setPolicyModalVisible(false);
          setPolicyModalData({});
        }}
        footer={{
          enable: false,
        }}
      >
        <AttachPolicies data={policyModalData} />
      </Modal>
    </React.Fragment>
  );
};

const ThemeModal = ({
  initialState,
  visible,
  setvisible,
  getTheme,
  source,
}: any) => {
  let onSubmit: any;
  return (
    <Modal
      key={"themeModal"}
      dataTestId="edit_theme"
      title={initialState ? "EDIT THEME" : "CREATE THEME"}
      visible={visible}
      onCancel={() => setvisible(false)}
      unmountOnCancel={true}
      footer={{
        enable: true,
        okText: initialState ? "SAVE" : "CREATE",
        cancelText: "CANCEL",
        onOk: () => {
          onSubmit();
          setvisible(false);
        },
      }}
    >
      <Theme
        data-test-id="theme"
        initialState={initialState}
        source={source}
        getTheme={() => getTheme()}
        onSumbit={(submit: any) => (onSubmit = submit)}
      />
    </Modal>
  );
};

export default Sidemenu;
